import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20fantasy%20game%20world%20with%20giant%20colorful%20mushrooms%20on%20rolling%20green%20hills%2C%20a%20small%20adventurer%20character%20jumping%20between%20mushroom%20platforms%2C%20warm%20golden%20sunlight%20through%20fluffy%20clouds%2C%20magical%20sparkles%20in%20the%20air%2C%20hand-drawn%20illustration%20style%2C%20playful%20and%20inviting%20atmosphere%2C%20rich%20earth%20tones%20with%20vibrant%20red%20and%20golden%20mushroom%20caps%2C%20soft%20whimsical%20lighting%2C%20wide%20panoramic%20composition&width=1600&height=900&seq=hero-mushroom-01&orientation=landscape"
        alt="踩蘑菇游戏世界"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
        <h1 className="text-3xl md:text-5xl font-heading text-white mb-4 leading-tight">
          踩蘑菇——经典小游戏玩法全攻略
        </h1>
        <p className="text-base md:text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          从新手入门到高手进阶，最全面的踩蘑菇攻略网站。掌握操作技巧、关卡路线、高分秘籍，开启你的蘑菇冒险之旅！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category?cat=xinshou-jiaocheng"
            className="bg-primary-500 text-background-50 px-8 py-3 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            新手入门指南
          </Link>
          <Link
            to="/category"
            className="bg-background-50/20 backdrop-blur-sm text-white border border-white/30 px-8 py-3 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            浏览全部攻略
          </Link>
        </div>
      </div>
    </section>
  );
}